import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataGrid, {
    Column,
    FilterRow,
    Paging,
    RemoteOperations,
    Scrolling
} from 'devextreme-react/data-grid';
import DataSource from 'devextreme/data/data_source';
import notify from 'devextreme/ui/notify';
import React, { useContext, useEffect, useState } from 'react';
import grantApi from '../../api/GrantApi.js';
import sharedApi from '../../api/SharedApi.js';
import userApi from '../../api/UserApi.js';
import { useAppContext } from '../shared/AppContext';

const GrantUserSelect = (props) => {

    const {
        grantId,
        hideSoSelect,
        setUpdatedSo
    } = props;

    const app = useAppContext();
    const [dataSource, setDataSource] = useState([]);

    useEffect(() => {

        var source = new DataSource({
            store: createStore({
                key: 'id',
                loadUrl: sharedApi.generateURL(`${grantApi.path}/${grantId}/users?role=SO`),
                onBeforeSend: (method, ajaxOptions) => {
                    ajaxOptions.xhrFields = { withCredentials: true };
                    ajaxOptions.headers = { 'Authorization': 'Bearer ' + userApi.getAccessToken() };
                },
            })
        });

        setDataSource(source);

    }, [grantId])

    const renderAssignSo = (cellInfo) => {
        const data = cellInfo.data;
        return (
            <a className={'portfolio-link'} onClick={(e) => { assignSo(data); }}>Assign</a>
        );
    };

    const assignSo = async (data) => {
        data.actionRole = app.userRole;
        await grantApi.assignSo(grantId, data);
        hideSoSelect();
        setUpdatedSo(data);
        notify(data.firstName + " " + data.lastName + " was successfully assigned as SO on this grant.");
    };

    if (grantId !== undefined) {
        return (
            <>
                <DataGrid
                    dataSource={dataSource}
                    height="100%"
                    repaintChangesOnly={true}
                    rowAlternationEnabled={true}
                    showBorders={true}
                    showColumnLines={true}
                    showRowLines={false}
                    wordWrapEnabled={true}
                >
                    <FilterRow visible={true} applyFilter={"auto"} />
                    <Paging defaultPageSize={100} />
                    <RemoteOperations
                        filtering={true}
                        paging={true}
                        sorting={true}
                        summary={true}
                        grouping={true}
                        groupPaging={true}
                    />
                    <Scrolling mode="virtual"></Scrolling>
                    <Column
                        dataField="id"
                        dataType="number"
                        visible={false}
                    ></Column>
                    <Column
                        dataField="firstName"
                    />
                    <Column
                        dataField="lastName"
                    />
                    <Column
                        dataField="email"
                    />
                    <Column
                        cellRender={renderAssignSo}
                    ></Column>
                </DataGrid>
            </>
        );
    }
    else {
        return (
            <></>
        );
    }
}

export default GrantUserSelect;

